export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_03.b7c40aea.jpg";